import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FavoriteState {
    constructor() {
        /**
         * Цвелевой элемент
         * @type {Element}
         */
        this.wrapper = null;

        /**
         * Обёртка вывода кол-ва избранного
         * @type {Element}
         */
        this.countWrapper = null;

        /**
         * Таймер для отсчёта показа сообщения о добавлении
         * @type {null}
         */
        this.timer = null;
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._subscribers();
    }

    /**
     * Получение элементов
     * @private
     */
    _getElements() {
        this.countWrapper = this.wrapper.querySelector('.j-favorite-state-count');
    }

    /**
     * Показывает кол-во элементов в избранном
     * @private
     * @param {number} count - количество квартир в избранном
     */
    _showCount(count) {
        if (Number(count) > 0 && this.countWrapper) {
            const value = Number(count) > 9 ? '9+' : count;

            this.countWrapper.innerText = value;
            this.countWrapper.classList.remove('is-empty');
        } else {
            this.countWrapper.innerText = '';
            this.countWrapper.classList.add('is-empty');
        }
    }

    /**
     * Получаем список избранных квартир из куки
     * @returns {array} список избранного из куки
     */
    _getFavorite() {
        const cookieFavorite = Utils.getCookie('favorites');

        if (!cookieFavorite) {
            return [];
        }

        return JSON.parse(cookieFavorite);
    }

    /**
     * Подписка
     * @private
     */
    _subscribers() {
        observer.subscribe('favorite:update', (count) => {
            this._showCount(count);
        });
    }
}

export default FavoriteState;
